export const SIGNUP_MODE_STORAGE_KEY = 'haastia.signup.accountMode';
export const SIGNUP_ACCOUNT_MODES = ['single', 'team'];

export const isSignupAccountMode = (value) => SIGNUP_ACCOUNT_MODES.includes(value);

export const getStoredSignupMode = () => {
  if (typeof window === 'undefined') return null;
  try {
    const value = window.sessionStorage.getItem(SIGNUP_MODE_STORAGE_KEY);
    return isSignupAccountMode(value) ? value : null;
  } catch (_error) {
    return null;
  }
};

// Reports whether the write actually landed. Callers must not assume the mode
// will still be readable on the next route: storage throws in privacy-restricted
// browsers, and a silent failure used to bounce /signup and /signup/details off
// each other forever.
export const storeSignupMode = (mode) => {
  if (typeof window === 'undefined' || !isSignupAccountMode(mode)) return false;
  try {
    window.sessionStorage.setItem(SIGNUP_MODE_STORAGE_KEY, mode);
    return true;
  } catch (_error) {
    // Storage can be unavailable in privacy-restricted browsers.
    return false;
  }
};

export const clearStoredSignupMode = () => {
  if (typeof window === 'undefined') return;
  try {
    window.sessionStorage.removeItem(SIGNUP_MODE_STORAGE_KEY);
  } catch (_error) {
    // Storage can be unavailable in privacy-restricted browsers.
  }
};

// `?mode=` is the only mode source that survives a browser with sessionStorage
// blocked (Safari private mode, in-app webviews), and /pricing links straight in
// with it, so it has to be readable on its own.
export const getSignupModeFromSearch = (search) => {
  if (typeof search !== 'string' || !search) return null;
  try {
    const value = new URLSearchParams(search).get('mode');
    return isSignupAccountMode(value) ? value : null;
  } catch (_error) {
    return null;
  }
};

// Stored mode wins — the user may have picked a different one after arriving via
// a ?mode= link — and the URL is the fallback when storage is unavailable.
export const getSignupMode = (search) =>
  getStoredSignupMode() || getSignupModeFromSearch(search);

export const getBusinessInviteTokenFromNext = (nextPath) => {
  if (typeof nextPath !== 'string' || !nextPath.startsWith('/join/business')) return '';
  try {
    const parsed = new URL(nextPath, 'https://haastia.local');
    return parsed.pathname === '/join/business' ? parsed.searchParams.get('token') || '' : '';
  } catch (_error) {
    return '';
  }
};
